import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from "@angular/router";
import {Title} from "@angular/platform-browser";
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-page-server-error',
    templateUrl: './page-server-error.component.html',
    styleUrls: ['./page-server-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, TranslatePipe]
})
export class PageServerErrorComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private title = inject(Title);

  code = 500;
  message = 'Server Error';

  ngOnInit(): void {
    this.title.setTitle('Page (500)');
    this.route.paramMap.subscribe(() => {
      this.code = window.history.state.code || 500;
      this.message = window.history.state.message || this.message;
    })
  }

}
